<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      show-icon
      title="会员在小程序「资源-企业详情-商机」对在架商机提交对接申请，平台核实后点「通过」，再按回拨电话转达商机发布方；不通过请填写原因，申请人会收到站内消息。"
    />
    <el-form :inline="true" :model="query" class="-mb-15px">
      <el-form-item label="处理状态">
        <el-select v-model="query.status" clearable class="!w-140px" placeholder="全部">
          <el-option label="待处理" value="pending" />
          <el-option label="已通过" value="approved" />
          <el-option label="未通过" value="rejected" />
        </el-select>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input
          v-model="query.keyword"
          clearable
          class="!w-200px"
          placeholder="对接事由 / 回拨电话"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item label="资源ID">
        <el-input v-model="query.resourceId" clearable class="!w-160px" placeholder="按资源ID筛选" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="申请人" min-width="160">
        <template #default="{ row }">
          <div class="flex items-center gap-8px">
            <el-avatar :size="26" :src="row.userAvatar">
              {{ (row.userNickname || '会').slice(0, 1) }}
            </el-avatar>
            <span>{{ row.userNickname || '未命名会员' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="resourceName" label="企业" min-width="150" show-overflow-tooltip>
        <template #default="{ row }">{{ row.resourceName || '资源#' + row.resourceId }}</template>
      </el-table-column>
      <el-table-column prop="bizOppTitle" label="对接商机" min-width="180" show-overflow-tooltip>
        <template #default="{ row }">{{ row.bizOppTitle || '商机已下架' }}</template>
      </el-table-column>
      <el-table-column prop="purpose" label="对接事由" min-width="220" show-overflow-tooltip />
      <el-table-column prop="contactMobile" label="回拨电话" width="130" />
      <el-table-column label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="statusTag(row.status)" size="small">{{ statusText(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rejectReason" label="未通过原因" min-width="140" show-overflow-tooltip>
        <template #default="{ row }">{{ row.rejectReason || '-' }}</template>
      </el-table-column>
      <el-table-column label="提交时间" width="170">
        <template #default="{ row }">{{ formatTime(row.createTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openDetail(row)">详情</el-button>
          <template v-if="row.status === 'pending'">
            <el-button
              v-hasPermi="['bosscircle:resource:audit']"
              link
              type="success"
              @click="handlePass(row)"
            >
              通过
            </el-button>
            <el-button
              v-hasPermi="['bosscircle:resource:audit']"
              link
              type="danger"
              @click="openReject(row)"
            >
              不通过
            </el-button>
          </template>
          <span v-else class="text-12px text-#909399">已处理</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog title="对接申请详情" v-model="detailVisible" width="680px">
    <el-descriptions v-if="current?.id" :column="2" border>
      <el-descriptions-item label="申请人">
        {{ current.userNickname || '未命名会员' }} #{{ current.userId }}
      </el-descriptions-item>
      <el-descriptions-item label="回拨电话">{{ current.contactMobile || '-' }}</el-descriptions-item>
      <el-descriptions-item label="企业">
        {{ current.resourceName || '资源#' + current.resourceId }}
      </el-descriptions-item>
      <el-descriptions-item label="资源ID">{{ current.resourceId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="对接商机" :span="2">
        {{ current.bizOppTitle || '商机已下架或不存在' }}
      </el-descriptions-item>
      <el-descriptions-item label="商机ID" :span="2">{{ current.bizOppId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="对接事由" :span="2">{{ current.purpose || '-' }}</el-descriptions-item>
      <el-descriptions-item label="处理状态">
        <el-tag :type="statusTag(current.status)" size="small">
          {{ statusText(current.status) }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="处理时间">{{ formatTime(current.handleTime) }}</el-descriptions-item>
      <el-descriptions-item label="未通过原因" :span="2">
        {{ current.rejectReason || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="提交时间" :span="2">
        {{ formatTime(current.createTime) }}
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-button @click="detailVisible = false">关 闭</el-button>
    </template>
  </Dialog>

  <Dialog title="不通过对接申请" v-model="rejectVisible" width="500px">
    <el-form ref="rejectFormRef" :model="rejectForm" :rules="rejectRules" label-width="90px">
      <el-form-item label="企业">{{ current?.resourceName || '资源#' + current?.resourceId }}</el-form-item>
      <el-form-item label="对接事由">{{ current?.purpose }}</el-form-item>
      <el-form-item label="未通过原因" prop="rejectReason">
        <el-input
          v-model="rejectForm.rejectReason"
          type="textarea"
          :rows="3"
          placeholder="请说明原因，申请人会在「我的对接申请」和站内消息里看到"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="rejectVisible = false">取 消</el-button>
      <el-button :loading="rejecting" type="danger" @click="submitReject">确定不通过</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { formatDate } from '@/utils/formatTime'
import * as Api from '@/api/business/resource'
import type { FormInstance, FormRules } from 'element-plus'

defineOptions({ name: 'BossCircleResourceContact' })

const route = useRoute()
const message = useMessage()

const loading = ref(false)
const list = ref<Api.ResourceContactVO[]>([])
const total = ref(0)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  status: (route.query.status as Api.ResourceContactStatus) || undefined,
  keyword: '',
  resourceId: (route.query.resourceId as string) || ''
})

const statusText = (s?: string) =>
  ({ pending: '待处理', approved: '已通过', rejected: '未通过' } as Record<string, string>)[s ?? ''] || '-'
const statusTag = (s?: string) => (s === 'approved' ? 'success' : s === 'rejected' ? 'info' : 'warning')

const formatTime = (value?: string | number) => (value ? formatDate(value) : '-')

const load = async () => {
  loading.value = true
  try {
    const params: any = { pageNo: query.pageNo, pageSize: query.pageSize }
    if (query.status) params.status = query.status
    if (query.keyword) params.keyword = query.keyword
    if (query.resourceId) params.resourceId = query.resourceId
    const data = await Api.getResourceContactPage(params)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const search = () => {
  query.pageNo = 1
  load()
}

const reset = () => {
  query.status = undefined
  query.keyword = ''
  query.resourceId = ''
  search()
}

const detailVisible = ref(false)
const current = ref<Api.ResourceContactVO>()

const openDetail = (row: Api.ResourceContactVO) => {
  current.value = row
  detailVisible.value = true
}

const handlePass = async (row: Api.ResourceContactVO) => {
  await message.confirm(
    `确认通过「${row.userNickname || '该会员'}」对「${row.bizOppTitle || '该商机'}」的对接申请吗？通过后请按回拨电话 ${row.contactMobile} 转达商机发布方。`
  )
  await Api.auditResourceContact({ id: row.id!, approved: true })
  message.success('已通过')
  detailVisible.value = false
  load()
}

const rejectVisible = ref(false)
const rejecting = ref(false)
const rejectFormRef = ref<FormInstance>()
const rejectForm = reactive<{ rejectReason: string }>({ rejectReason: '' })
const rejectRules = {
  rejectReason: [{ required: true, message: '未通过原因不能为空', trigger: 'blur' }]
} as FormRules

const openReject = (row: Api.ResourceContactVO) => {
  current.value = row
  rejectForm.rejectReason = ''
  rejectVisible.value = true
  nextTick(() => rejectFormRef.value?.clearValidate())
}

const submitReject = async () => {
  await rejectFormRef.value?.validate()
  rejecting.value = true
  try {
    await Api.auditResourceContact({
      id: current.value!.id!,
      approved: false,
      rejectReason: rejectForm.rejectReason.trim()
    })
    message.success('已标记不通过')
    rejectVisible.value = false
    load()
  } finally {
    rejecting.value = false
  }
}

onMounted(load)
</script>
